(function () {
  var yotpoScripts = [
    'https://cdn-widgetsrepository.yotpo.com/v1/loader/rJDOAjrYGgPAY2G5dAXKO0GZmOxFOCKNsmCdbn8s?languageCode=en',
    'https://cdn-widgetsrepository.yotpo.com/v1/loader/wu8VdAuXPWA1WxvFh-aCkw'
  ];

  var loaded = {};

  function hasMarketingConsent() {
    return (
      window.Shopify &&
      Shopify.customerPrivacy &&
      typeof Shopify.customerPrivacy.marketingAllowed === 'function' &&
      Shopify.customerPrivacy.marketingAllowed()
    );
  }

  function loadYotpoScripts() {
    if (!hasMarketingConsent()) {
      return;
    }

    yotpoScripts.forEach(function (src) {
      if (loaded[src]) {
        return;
      }

      if (document.querySelector('script[src="' + src + '"]')) {
        loaded[src] = true;
        return;
      }

      var script = document.createElement('script');
      script.src = src;
      script.async = true;

      document.head.appendChild(script);

      loaded[src] = true;

      console.log('Loaded Yotpo after consent:', src);
    });
  }

  /*
   * If consent has already been granted from a previous visit,
   * load Yotpo once Shopify's privacy API becomes available.
   */
  var consentCheckAttempts = 0;

  var consentCheck = setInterval(function () {
    consentCheckAttempts++;

    if (
      window.Shopify &&
      Shopify.customerPrivacy &&
      typeof Shopify.customerPrivacy.marketingAllowed === 'function'
    ) {
      clearInterval(consentCheck);
      loadYotpoScripts();
    }

    if (consentCheckAttempts >= 50) {
      clearInterval(consentCheck);
    }
  }, 100);

  /*
   * Load immediately after the visitor grants consent.
   */
  document.addEventListener('visitorConsentCollected', function () {
    loadYotpoScripts();
  });

  /*
   * Keep this because you're already using Consentmo's
   * Shopify privacy integration.
   */
  document.addEventListener(
    'shopify:customer_privacy:loaded',
    loadYotpoScripts
  );
})();